import React, { useContext } from "react";
import MainLayout from "../../layouts/MainLayout/MainLayout";
import "./Dashboard.css";
import ActiveCourseCard from "../../features/Dashboard/CourseCard/ActiveCourseCard";
import DailyRecommendationCard from "../../features/Dashboard/DailyRecommendationCard/DailyRecommendationCard";
import AppContext from "../../contexts/AppContext";
import ReminderAndSponsors from "../../features/Dashboard/ReminderAndSponsors/ReminderAndSponsors";
import Surveys from "../../features/Surveys/Surveys";
import Tour from "../../features/Dashboard/DashboardComponents/Tour";
import CalendarAside from "../../components/CalendarAside/CalendarAside";
import StatsCounters from "../../features/Dashboard/StatsCounters/StatsCounters";


function Dashboard() {
   const { currentUser, remainingSurvey } = useContext(AppContext);

   return (
      <>
         <Tour />
         <MainLayout>
            <div className="dashboard__layout">
                <div className="dashboard__main">
                    <div className="dashboard__left">
                        <div className="dashboard__header">
                            <h1 className="dashboard__header__welcome">
                                Bienvenido, {currentUser.name}
                            </h1>
                            <StatsCounters />
                        </div>
                        <div className="dashboard__bento-course">
                            <ActiveCourseCard/>
                        </div>
                        <div className="dashboard__bento-news dashboard__glass-card">
                            <ReminderAndSponsors/>
                        </div>
                        <div className="dashboard__bento-recommendation dashboard__glass-card">
                            <DailyRecommendationCard/>
                        </div>
                        {remainingSurvey?.length > 0 && <div className="dashboard__bento-surveys dashboard__glass-card">
                            <Surveys remainingSurvey={remainingSurvey}/>
                        </div>}
                    </div>
                    <div className="dashboard__right">
                        <CalendarAside />
                    </div>
                </div>
            </div>
         </MainLayout>
      </>
   );
}

export default Dashboard;
